/**
 * LanguageSelector.tsx
 *
 * Questo componente serve a mostrare i pulsanti per cambiare lingua.
 * Al momento ho lasciato solo "it" (italiano), ma volendo si possono aggiungere
 * altre lingue semplicemente modificando l'array dentro al map().
 *
 * Nota: non gestisco direttamente il cambio lingua qui dentro, ma passo la logica
 * al padre tramite la prop `handleLanguageChange`. Questo mi permette di avere
 * più flessibilità su come gestire lo switch (redirect, reload, ecc.).
 */

import React from "react";
import { useTranslation } from "react-i18next";

interface LanguageSelectorProps {
  handleLanguageChange: (lang: string) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ handleLanguageChange }) => {
  const { i18n } = useTranslation();

  return (
    <div className="language-selector">
      {/* 
        Nota per chi svilupperà dopo di me:
        - Qui c’è l’array con le lingue disponibili. Ora è solo ["it"], ma puoi estenderlo
          a ["it", "en", "fr"] ecc. senza rompere nulla.
        - Per ogni lingua, genero un pulsante con la bandierina.
      */}
      {["it", "en"].map((lang) => (
        <button
          key={lang}
          className={`language-button ${i18n.language === lang ? "active" : ""}`}
          onClick={() => handleLanguageChange(lang)}
        >
          {/* Uso le immagini in /assets/images/lang/ per mostrare la bandierina */}
          <img
            src={`/assets/images/lang/${lang}.png`}
            alt={lang.toUpperCase()}
            title={lang.toUpperCase()}
          />
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;